import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export type OpsHubFeedTone = 'green' | 'teal' | 'amber' | 'red' | 'gray';

export interface OpsHubFeedItem {
  id: string;
  time: string;
  who: string;
  what: string;
  tone: OpsHubFeedTone;
}

export interface UseOpsHubFeedResult {
  isLoading: boolean;
  isError: boolean;
  data: OpsHubFeedItem[] | undefined;
}

export function useOpsHubFeed(): UseOpsHubFeedResult {
  return useQuery({
    queryKey: ["ops-hub-feed"],
    queryFn: () => api<OpsHubFeedItem[]>("/admin/ops-hub/events?limit=10"),
    staleTime: 15_000,
  });
}
